<template>
  <el-card class="detail">
    <div class="line"></div>
    <div class="title-1">
      <img src="@/assets/chengjiao.png" />
      <span class="m-l-10">成交记录详情</span>
    </div>
    <div class="title-2">
      <span>成交信息</span>
    </div>
    <div class="content">
      <el-form :model="data" label-width="155px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交单号">
              {{ data.id }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="市场">
              {{ data.marketName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="报价方向">
              {{ data.billType | keyFilter('transation', 'billType') }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成交状态">
              <el-tag :type="getColor()">{{ data.tradingStatus | keyFilter('transation', 'tradingStatus') }}</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交单价">
              {{ data.price ? '￥' : '' }}{{ data.price | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成交数量">
              {{ data.qty }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交总价">
              {{ data.amount ? '￥' : '' }}{{ data.amount | thousandMark }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成交时间">
              {{ data.tradingDate }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="成交状态">
              {{ data.tradingStatus | keyFilter('transation', 'tradingStatus') }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="title-2">
      <span>产品信息</span>
    </div>
    <div class="content p-b-50">
      <el-form :model="data" label-width="155px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="商品名称">
              {{ product.productName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="仓库">
              {{ product.whName }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="交货日期">
              {{ product.deliveryDate }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="btn-box">
      <el-button plain @click="close">返回</el-button>
    </div>
  </el-card>
</template>

<script>
import API from '@/api'
export default {
  name: 'detail',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data: {},
      product: {},
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const param = {
        id: this.row.id
      }
      API.transationManage.tradingDetail(param).then(res => {
        this.data = res.data
        this.product = res.data.product
      })
    },
    // 委托状态颜色
    getColor () {
      switch (this.data.tradingStatus) {
        case 'CANCEL': // 已过期
          return 'info'
        case 'BREAK': // 违约
          return 'info'
        case 'PART_OK': // 部分成交
          return 'warning'
        case 'ALL_OK': // 全部成交
          return 'success'
        case 'SUCCESS': // 交易成功
          return 'success'
        default:
          return ''
      }
    },
    close () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="scss" scoped>
.title-1 {
  margin-bottom: 20px;
  height: 40px;
  line-height: 40px;
  span {
    font-size: 24px;
    font-weight: 600;
  }
  img {
    position: relative;
    top: -4px;
  }
}
.title-2 {
  padding: 20px 50px;
  top: 50px;
  border-bottom: 1px dashed #ebebeb;
  span {
    font-size: 16px;
    font-weight: 600;
  }
}
.detail ::v-deep {
  position: relative;
  .line {
    width: 100%;
    height: 1px;
    background-color: #ebebeb;
    top: 80px;
    left: 0;
    position: absolute;
  }
  .el-row {
    border-bottom: 1px dashed #ebebeb;
    margin: 0;
    padding: 10px 0px;
    height: 59px;
    line-height: 59px;
  }
  .el-col {
    padding: 0 50px;
  }
  .el-form-item {
    margin: 0;
  }
}
.p-b-50 {
  padding-bottom: 50px;
}
.btn-box {
  width: calc(100% - 200px);
  text-align: center;
  padding: 30px;
  position: fixed;
  bottom: 0;
  left: 200px;
  background-color: #ffffff;
  background-color: #ffffff;
  box-shadow: 0px -4px 20px 0px rgba(110, 110, 110, 0.1);
  button {
    width: 124px;
    height: 40px;
    background-color: #ffc600;
    border-radius: 4px;
  }
}
</style>
